<ng-container *transloco="let t">
    <div class="card-body">
        <div
            *ngIf="!uploadedFile && !isUploading"
            class="file-drop-zone position-relative"
            [class.drag-over]="isDragOver"
            [class.disabled]="disabled"
            [class.has-errors]="hasValidationErrors"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="triggerFileInput()"
        >
            <input
                class="fileDrop"
                type="file"
                #uploadFileInput
                [accept]="acceptableFilesString"
                [disabled]="disabled"
                (change)="onFileChange($event)"
                style="display: none"
            />
            <div class="upload-content">
                <div class="upload-icon-container">
                    <i
                        data-feather="download"
                        [size]="48"
                        class="upload-icon"
                    ></i>
                </div>
                <h5 class="upload-title">
                    {{
                        t(
                            "Upload area title (upload document widget) - Drop files here or click to upload"
                        )
                    }}
                </h5>
                <p class="upload-subtitle">
                    {{
                        t(
                            "Upload area subtitle (upload document widget) - Supports PDF DOCX files"
                        )
                    }}
                </p>
            </div>
        </div>
        <!-- Uploaded File Display -->
        <div *ngIf="uploadedFile" class="uploaded-file-zone">
            <div class="uploaded-file-content">
                <div class="file-info">
                    <div class="file-icon-container">
                        <i
                            [data-feather]="fileIcon"
                            [size]="32"
                            class="file-icon"
                        ></i>
                    </div>
                    <div class="file-details">
                        <h6 class="file-name">{{ uploadedFile.name }}</h6>
                        <p class="file-size">{{ fileSizeFormatted }}</p>
                    </div>
                </div>
                <div class="file-actions" *ngIf="!disabled">
                    <button
                        type="button"
                        class="btn btn-outline-danger btn-sm"
                        (click)="removeFile()"
                        [title]="
                            t(
                                'Remove file button tooltip (upload document widget) - Remove file'
                            )
                        "
                    >
                        <i data-feather="trash-2" [size]="16"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Validation Errors -->
        <div *ngIf="validationErrors.length > 0" class="validation-errors mt-2">
            <div
                *ngFor="let error of validationErrors"
                class="error-message text-danger small"
            >
                {{ error.message }}
            </div>
        </div>
    </div>
</ng-container>
